<template>
  <div>
    <el-form :model="form" ref="hashForm" :rules="rules" label-width="80px">
      <el-form-item label="姓名" prop="name">
        <el-input
          v-model="form.name"
          clearable
          placeholder="请输入姓名"
          style="width: 220px"
        ></el-input>
        <span class="result_value">{{result.name_hash_value}}</span>
      </el-form-item>
      <el-form-item label="手机号" prop="phone">
        <el-input
          v-model="form.phone"
          clearable
          placeholder="请输入手机号"
          style="width: 220px"
        ></el-input>
        <span class="result_value">{{result.phone_hash_value}}</span>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">转译</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  data() {
    const checkPhone = (rule, value, callback) => {
      if (!value) {
        // callback(new Error("请输入手机号!"));
        callback();
      }
      setTimeout(() => {
        if (value.length !== 11) {
          callback(new Error("手机号码请输入11位！"));
        }
        if (!/^1[3456789]\d{9}$/.test(value)) {
          callback(new Error("请输入正确的手机号！"));
        } else {
          callback();
        }
      }, 50);
    };
    return {
      form: {
        name: "",
        phone: "",
      },
      result: {},
      rules: {
        name: [{ required: false, message: "请输入姓名!", trigger: "blur" }],
        phone: [{ required: false, validator: checkPhone, trigger: "blur" }],
      },
    };
  },
  methods: {
    onSubmit() {
      this.$refs.hashForm.validate((valid) => {
        if (valid) {
          let params = {
            ...this.form,
          };
          if(!params.name && !params.phone){
            this.result = {}
            return 
          }
          this.httpGet("/conf/get/hash", params).then((res) => {
            this.result = res.data;
          });
        }else{
          return false
        }
      })
    },
  },
};
</script>
<style lang="scss" scoped>
.result_value{
  margin-left: 10px;
}
</style>